import React from 'react';

import { P } from '../P/P';

import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';

export const LE1_4 = () => (
  <Section>

    <UL disc gapAfter>
      <LI>
        Menge der Teile (nur Oberbekleidung, also keine Unterwäsche und Strümpfe)
      </LI>
      <LI>
        Wie viele davon werden regelmäßig (mindestens zweimal monatlich) angezogen?
      </LI>
      <LI>
        Auswahl von 10 (Lieblings-)Kleidungsstücken: Welche Produktionsländer sind auf dem Herstellerschild zu finden? Und aus welchem Material ist das Kleidungsstück?
      </LI>
    </UL>

    <P>
      Für fortgeschrittenere SuS: Lassen Sie eine eigene Statistik des jeweiligen Kleiderschrank-Inhaltes zusammenstellen:
    </P>

    <UL disc gapAfter>
      <LI>Herkunftsländer</LI>
      <LI>Material</LI>
    </UL>

    <P>Die Auswertung der Analyse erfolgt zu Beginn der Lerneinheit 3.</P>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE1_4.js